/*global angular */
angular.module('CarreExample', [
    'ngCookies',
    'ngSanitize',
    'ngAnimate',
    'cfp.loadingBar',
    'ngOnload'
])
.config(function($locationProvider,$compileProvider) {
$locationProvider.html5Mode(true);
  
// Disable log
$compileProvider.debugInfoEnabled(false);
  
})
.constant('CONFIG',{
'language':'en'
});

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-60507179-3', 'auto');
ga('send', 'pageview');

/*global angular,RiskEvidenceConditionParser */
angular.module('CarreExample')
  .controller('ExampleController', function($scope, $location, API,$sce, $timeout,cfpLoadingBar,CONFIG) {

    //set up the urls 
    var CARRE_DEVICES = API.accounts;
    var testToken = 'e097e48bbc1e35d83f5289a053d088a06188b6f2',token=null;
    if($location.search().token) token = $location.search().token;
    
    //clean up the browser url
    $location.url('/').replace();
    var baseUrl = $location.absUrl();
    $scope.loginUrl = CARRE_DEVICES + '/login?next=' + baseUrl;
    $scope.logoutUrl = CARRE_DEVICES + '/logout?next=' + baseUrl;
    
    // set default visualization type
    $scope.visualizationType = 'list';

    // Retrieving a cookie and set initial user object
    API.user(token).then(function(res) {
      $scope.user = {
        oauth_token: res.oauth_token,
        username: res.username
      };
      $scope.loadData();
    });

    $scope.loadTestUser = function() { 
      API.user(testToken).then(function(res) {
        $scope.user = {
          oauth_token: res.oauth_token,
          username: res.username
        };
        $scope.loadData();
      });
    };

    $scope.loadData = function() {
      $scope.measurements=[];
      $scope.loading = true;
      cfpLoadingBar.start();
      getMeasureListWithLatestValue();
    };

    var results = {};
    
    function getMeasureListWithLatestValue() {

      if (!$scope.user.username) return;
      API.lastMeasurements($scope.user).then(function(res) {
        console.log(res);
        var data = res.data;

        results.predicates = [];
        results.values = {};
        results.observable_names = {};
        results.ob_dates = {};

        data.map(function(obj) {
          results.predicates.push(obj.p.value.replace("http://carre.kmi.open.ac.uk/ontology/sensors.owl#", ":"));
          results.values[makeLabel(obj.ob.value)] = obj.value.value;
          results.observable_names[makeLabel(obj.ob.value)] = obj.ob_name.value;
          results.ob_dates[makeLabel(obj.ob.value)] = obj.date.value;
        });

        //get the risk evidences
        getRiskEvidences();
      }, function(err) { console.log("Error in query measurementList"); console.log(err); });


    }


    function getRiskEvidences() {

      API.risk_evidences($scope.user, results.predicates).then(function(res) {
        var data = res.data;
        results.summary = [];
        results.risk_evidences = {};
        results.educational_resources = [];
        results.risk_element_names = [];
        results.risk_factors = {};
        results.total_risk_evidences = data.length;
        data.forEach(function(rv) {
          var result = RiskEvidenceConditionParser.evaluate(rv.condition.value, results.values);

          //             console.log(
          //               makeLabel(rv.risk_factor.value),
          //               makeLabel(rv.risk_evidence.value),
          //               result,
          //               rv.condition.value,getValues(results.values).join("|"),
          //               "---------"
          //             );


          if (result) {

            var risk_factor = makeLabel(rv.risk_factor.value);
            var risk_evidence = makeLabel(rv.risk_evidence.value);
            var rf_source = makeLabel(rv.has_risk_factor_source.value);
            var rf_target = makeLabel(rv.has_risk_factor_target.value);
            var rf_source_name = makeLabel(rv.rl_source_name.value);
            var rf_target_name = makeLabel(rv.rl_target_name.value);
            var rf_label = makeLabel(rv.rl_source_name.value) + " --> " + makeLabel(rv.rl_target_name.value);
            
            // populate risk element names
            if(results.risk_element_names.indexOf(rf_source_name)===-1) results.risk_element_names.push(rf_source_name);
            if(results.risk_element_names.indexOf(rf_target_name)===-1) results.risk_element_names.push(rf_target_name);
            
            
            results.risk_factors[risk_factor] = results.risk_factors[risk_factor] || {
              label: rf_label,
              source:rf_source,
              target:rf_target,
              evidences: []
            };

            results.risk_factors[risk_factor].evidences.push(risk_evidence);
            results.risk_evidences[risk_evidence] = {
              confidence_interval_min: rv.confidence_interval_min.value,
              confidence_interval_max: rv.confidence_interval_max.value,
              risk_evidence_ratio_value: rv.risk_evidence_ratio_value.value
            };

          }

        });
        console.log(results);
        display(results);
        $scope.loading = false;
        //           console.log(
        //             results.risk_factors,
        //             results.values,
        //             results.summary.length+"/"+results.total_risk_evidences);

      });

    }

    function display(results) {

      $scope.risk_factors = [];
      //make risk factors with evidences
      for (var rf in results.risk_factors) {
        $scope.risk_factors.push({
          label: results.risk_factors[rf].label,
          link: "https://entry.carre-project.eu/risk_factors/" + rf,
          evidences: results.risk_factors[rf].evidences.map(function(ev) {
            return {
              link: "https://entry.carre-project.eu/risk_evidences/" + ev,
              label: ev,
              ratio: results.risk_evidences[ev].risk_evidence_ratio_value
            };
          })
        });
      }
      $scope.measurements = [];
      //make measurements
      for (var ob in results.observable_names) {
        $scope.measurements.push({
          label: results.observable_names[ob],
          link: "https://entry.carre-project.eu/observables/" + ob,
          value: results.values[ob],
          date: new Date(results.ob_dates[ob]).toLocaleString()
        });
      }
      setGraphUrl();
      
      // make educational resources
      $scope.educational=[];
      $scope.educational = results.risk_element_names.map(function(rl){
        return {
          link:'https://edu.carre-project.eu/search/'+encodeURI(rl),
          label:rl
        }
      })
      //select first
      $scope.selectEducational($scope.educational[0].label);

    }
    
    // Change language specific
    $scope.lang=CONFIG.language;
    $scope.changeLanguage = function(){
      CONFIG.language = $scope.lang;
      $scope.loadData();
    }
    
    
    $scope.iframeLoaded=function(){
      $scope.iframesLoaded++;
      if($scope.iframesLoaded===1) {
        cfpLoadingBar.complete();
      }
    };
    
    function setGraphUrl(){
      $scope.iframesLoaded=0;
      
      var base = "//entry.carre-project.eu/";
      // var base = "//beta.carre-project.eu:3000/#/";
      var params = "explore?embed=true&hidemenu=true&showonlygraph=true&elementstype=risk_evidences&lang="+CONFIG.language;
      var url = base+params+"&elements="+Object.keys(results.risk_evidences).join(",");
      $scope.entrysystemUrlSankey = $sce.trustAsResourceUrl(url+"&graphtype=sankey");
      // $scope.entrysystemUrlNetwork = $sce.trustAsResourceUrl(url+"&graphtype=network");
    }


    $scope.selectEducational=function(rl){
      $scope.educationalTerm = rl;
      $scope.showEducational=false;
      cfpLoadingBar.start();
      var base = "//edu.carre-project.eu/search/";
      // var base = "//beta.carre-project.eu:8080/search/";
      var url = base+encodeURI(rl);
      $scope.educationalObjectUrl = $sce.trustAsResourceUrl(url+"?embed=true&lang="+CONFIG.language);
      $timeout(function(){
        $scope.showEducational=true;
        cfpLoadingBar.complete();
      },2000);
    }

    function makeLabel(str) {
      var result = "";
      if (str.indexOf("#") >= 0) {
        result = str.substring(str.lastIndexOf("#") + 1)
          .replace("risk_factor_association_type", "");
      } else result = str.substring(str.lastIndexOf("/") + 1);
      if (result.indexOf("RF_") +
        result.indexOf("OB_") +
        result.indexOf("RV_") +
        result.indexOf("RL_") > -4) return result;
      else return result.replace(/[_-]+/g, " ");
    }
    

  });
  
/*global angular */
angular.module('CarreExample')
  .service('API', function($http, $cookies, $q,CONFIG) {

    //set up the urls 
    var CARRE_DEVICES = 'https://devices.duth.carre-project.eu/devices/accounts';
    var URL = 'https://devices.duth.carre-project.eu/ws/'; 
    var prefixes = "PREFIX xsd: <http://www.w3.org/2001/XMLSchema#> \n\
            PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> \n\
            PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> \n\
            PREFIX : <http://carre.kmi.open.ac.uk/ontology/sensors.owl#> \n\
            PREFIX risk: <http://carre.kmi.open.ac.uk/ontology/risk.owl#> \n\
            PREFIX carreManufacturer: <http://carre.kmi.open.ac.uk/manufacturers/> \n\
            PREFIX carreUsers: <https://carre.kmi.open.ac.uk/users/> \n ";

    
  this.exports={
    'accounts': CARRE_DEVICES,
    'user': getUser,
    'lastMeasurements': get_lastMeasurements,
    'risk_evidences': get_risk_evidences
  };
  
  function getUser(token){
    var TOKEN = $cookies.get('CARRE_USER') || token || '';
    //validate cookie token with userProfile api function and get username userGraph
    if (TOKEN.length > 0) {
      return $http.get(URL + 'userProfile?token=' + TOKEN).then(function(res) {
        return {
          oauth_token: TOKEN,
          username: res.data.username,
          email: res.data.email
        };
      }, function(err) {
        console.log(err);
        return {}
      });
    } else {
      var r=$q.defer();
      r.reject({})
      return r.promise;
    }
  }
  
  
  function get_lastMeasurements(user) {
  
    console.log("Get Measurement of List ");

    var query = prefixes +
    "SELECT ?date ?p ?value ?ob ?ob_name FROM <https://carre.kmi.open.ac.uk/users/"+user.username+"> FROM <http://carre.kmi.open.ac.uk/riskdata> WHERE {  \n\
    { \n\
    SELECT max(xsd:datetime(?d)) as ?date ?p FROM <https://carre.kmi.open.ac.uk/users/"+user.username+"> WHERE { \n\
            ?m :has_date / :has_value ?d ; ?p ?o . \n\
            ?o :has_value ?v1 . \n\
                FILTER(!(?p = :has_date) && !(?p = :has_start_date)&& !(?p = :has_end_date) && !(?p = :has_sleep_status)) \n\
        } GROUP BY ?p } \n\
    ?measurement :has_date / :has_value ?dates ; ?p ?o . \n\
    ?o :has_value ?value . ?ob a risk:observable ; risk:has_external_predicate ?p; risk:has_observable_name ?ob_name.  \n\
    FILTER (lang(?ob_name)='"+CONFIG.language+"') \n\
    FILTER(xsd:datetime(?dates) = ?date) \n\
    } \n";
  
    console.log(query);
    return $http.post(URL+'query?token='+user.oauth_token+'&sparql='+encodeURIComponent(query));
    

  }
  

  
  function get_risk_evidences(user,predicates) {

    console.log("Get RiskEvidences of List ");
    var query = prefixes+"SELECT DISTINCT ?risk_evidence ?condition ?confidence_interval_min ?confidence_interval_max ?risk_evidence_ratio_value ?risk_evidence_ratio_type ?risk_factor ?has_risk_factor_source ?has_risk_factor_target ?rl_source_name ?rl_target_name ?has_risk_factor_association_type FROM <http://carre.kmi.open.ac.uk/riskdata> WHERE {  \n "+
    "  ?risk_evidence a risk:risk_evidence ;  \n "+
    "  risk:has_risk_factor ?risk_factor;  \n "+
    " risk:has_risk_evidence_ratio_type ?risk_evidence_ratio_type;  \n "+
    "   risk:has_risk_evidence_ratio_value ?risk_evidence_ratio_value;  \n "+
    "   risk:has_confidence_interval_max ?confidence_interval_max;  \n "+
    "   risk:has_confidence_interval_min ?confidence_interval_min;  \n "+
    "   risk:has_risk_evidence_observable ?ob ;  \n "+
    "   risk:has_observable_condition ?condition .  \n "+
    " #details for risk factor  \n "+
    " ?risk_factor risk:has_risk_factor_association_type ?has_risk_factor_association_type;  \n "+
    " risk:has_risk_factor_source ?has_risk_factor_source;  \n "+
    " risk:has_risk_factor_target ?has_risk_factor_target.  \n "+
    " ?has_risk_factor_source risk:has_risk_element_name ?rl_source_name.  \n "+
    " ?has_risk_factor_target risk:has_risk_element_name ?rl_target_name.   \n "+
    " FILTER(lang(?rl_source_name)='"+CONFIG.language+"')   \n "+
    " FILTER(lang(?rl_target_name)='"+CONFIG.language+"')   \n "+
    " {  \n "+
    "  SELECT ?ob FROM <http://carre.kmi.open.ac.uk/riskdata> WHERE {  \n "+
    "  ?ob a risk:observable ;  \n "+
    "         risk:has_external_predicate ?p.    \n "+
    " VALUES ?p {  \n "+predicates.join(" ")+" }  \n "+
    " }  \n "+
    " }  \n "+
    " }";


    return $http.post(URL+'query?token='+user.oauth_token+'&sparql='+encodeURIComponent(query));
    

  }
  


  
  return this.exports;
  
});